import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'reactstrap';
import AppContainer from '../../../components/AppContainer';
import RecordBinderCard from '../../../components/RecordBinderCard';
import RecordFiltersModal from '../../../components/RecordFiltersModal';
import withRouter from '../../../routes/withRouter';
import InfiniteScroll from 'react-infinite-scroll-component';
import AssetConstants from '@progressivebeef/shared/src/constants/AssetConstants';

import { globalHelper } from '@progressivebeef/shared/src/helpers';
import RecordBinderHelper from '@progressivebeef/shared/src/helpers/RecordBinderHelper';
import localization from '@progressivebeef/shared/src/localization/i18n';
import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';

import {
  getRecordBindersRequest,
  searchRecordBinders,
  filterRecordBinders,
  resetRecordBinderErrorProps,
  setCurrentRecordBinder,
} from '@progressivebeef/shared/src/store/actions/recordBinder';
import RouteConstants from '@progressivebeef/shared/src/constants/RouteConstants';
import {
  BOTTOM_BAR_TABS,
  RECORD_BINDER_STATUS,
  ERROR_SCREEN_TYPES,
} from '@progressivebeef/shared/src/constants/AppConstants';
import { showErrorAlert } from '../../../components/Alerts';
import { setBottomBarTab } from '@progressivebeef/shared/src/store/actions/view';
import NoRecordsFound from '../../../components/NoRecordsFound';
import PBIcon from '../../../components/PBIcon';
import './style.scss';

class RecordBinder extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showFilterModal: false,
    };
  }

  componentDidMount() {
    const { user } = this.props;
    
    if (!RecordBinderHelper.canUserViewRecordBinder(user)) {
      this.props.history.push(RouteConstants.DASHBOARD);
      return;
    }
    
    this.props.setBottomBarTab(BOTTOM_BAR_TABS.RECORD);
    this.props.getRecordBinders({ update: true });
    window.addEventListener('offline', this.handleOffline);
  }

  componentWillUnmount() {
    window.removeEventListener('offline', this.handleOffline);
  }

  handleOffline = () => {
    const hasRecordBinders = this.props.recordBinders?.length > 0;
    if (hasRecordBinders) {
      showErrorAlert(localization[getLocale()].NO_INTERNET_CONNECTION);
    }
  };

  componentDidUpdate(prevProps) {
    const { error, selectedFeedyard } = this.props;
    
    if (selectedFeedyard && selectedFeedyard.feedlot_id && 
        (!prevProps.selectedFeedyard || !prevProps.selectedFeedyard.feedlot_id)) {
        this.props.getRecordBinders({ update: false });
    }
    
    const hasRecords = this.props.recordBinders?.length > 0;
    const showingServerErrorPlaceholder = error && Object.keys(error).length !== 0 && !hasRecords;
    if (error && error !== prevProps.error && Object.keys(error).length !== 0 && !showingServerErrorPlaceholder) {
      showErrorAlert(error && error.message, [
        {
          text: localization[getLocale()].OK,
          onPress: () => {
            this.props.resetRecordBinderErrorProps();
          },
        },
      ]);
    }
  }

  onRefresh = () => {
    if (navigator.onLine) {
      this.props.getRecordBinders({ update: true });
    } else {
      showErrorAlert(localization[getLocale()].OFFLINE_MODE_REFRESH_ERROR);
    }
  };

  onCardPress = (item) => {
    const { history, setCurrentRecordBinder } = this.props;
    setCurrentRecordBinder(item);
    
    history.push(RouteConstants.RECORD_BINDER_DETAIL, {
      currentRecordBinder: item,
    });
  };

  onSearchPress = (query) => {
    this.props.searchRecordBinders(query);
    this.props.getRecordBinders({ update: false });
  };

  onFilterPress = () => {
    this.setState({ showFilterModal: true });
  };

  onFilterApply = (filters) => {
    const { sort } = this.props.filter;
    const { status, startDate, endDate } = filters;
    this.props.filterRecordBinders({ sort, status, startDate, endDate });
    this.props.getRecordBinders({ update: false });
    this.setState({
      showFilterModal: false,
    });
  };

  onFilterClear = () => {
    const { sort } = this.props.filter;
    this.props.filterRecordBinders({
      status: RECORD_BINDER_STATUS.ACTIVE,
      startDate: null,
      endDate: null,
      sort,
    });
    this.props.getRecordBinders({ update: false });
    this.setState({
      showFilterModal: false,
    });
  };

  onFilterCancel = () => {
    this.setState({ showFilterModal: false });
  };

  onDeletePress = () => {
    const { history, recordBinders } = this.props;
    history.push(RouteConstants.RECORD_BINDER_BIN, {
      recordBinders,
    });
  };

  renderRightHeader = () => {
    const { filter } = this.props;
    const { user } = this.props;
    const hasActiveFilters = filter?.status || filter?.startDate || filter?.endDate;
    const hasWritePermission = RecordBinderHelper.canUserWriteRecordBinder(user);

    return (
      <div>
        <div className="head-icon right-align">
          <div className="hald-icon-box">
            <div onClick={this.onFilterPress}>
              <img
                alt="description"
                src={
                  hasActiveFilters
                    ? AssetConstants.recordFilterFilled
                    : AssetConstants.recordFilter
                }
              />
            </div>
          </div>
          {hasWritePermission && (
            <div className="hald-icon-box">
              <div onClick={this.onDeletePress}>
                <img
                  alt="description"
                  src={AssetConstants.recordTrash}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  sortPress = () => {
    const { sort } = this.props.filter;
    this.props.filterRecordBinders({ ...this.props.filter, sort: !sort });
    this.props.getRecordBinders({ update: false });
  };

  renderLeftHeader = () => {
    const { sort } = this.props.filter;
    if (sort) {
      return (
        <div
          onClick={() => this.sortPress()}
          className="feedyard-head-icon left-align">
          <img alt="description" src={AssetConstants.timeSort} />
        </div>
      );
    } else {
      return (
        <div className="head-icon left-align">
          <PBIcon onPress={() => this.sortPress()} name={'sort-alpha-up'} />
        </div>
      );
    }
  };

  render() {
    const { isLoading, query, filter, error, recordBinders } = this.props;
    const { showFilterModal } = this.state;
    const recordBindersData = recordBinders || [];
    const hasRecordBinders = recordBindersData.length > 0;
    const isNoInternet = !navigator.onLine && !hasRecordBinders;
    const isServerError =
      !isNoInternet &&
      error &&
      Object.keys(error).length !== 0 &&
      !hasRecordBinders;

    const screenType = isNoInternet
      ? ERROR_SCREEN_TYPES.NETWORK_ERROR
      : isServerError
        ? ERROR_SCREEN_TYPES.SERVER_ERROR
        : ERROR_SCREEN_TYPES.NO_RECORDS;

    return (
      <AppContainer
        title={localization[getLocale()].RECORD_BINDER}
        searchText={query || ''}
        onSearchPress={this.onSearchPress}
        iconHeader={true}
        IconRightHeader={this.renderRightHeader}
        IconLeftHeader={this.renderLeftHeader}
        history={this.props.history}>
        <RecordFiltersModal
          show={showFilterModal}
          onRequestClose={this.onFilterCancel}
          onApply={this.onFilterApply}
          onClear={this.onFilterClear}
          selectedStatus={filter?.status || null}
          selectedStartDate={filter?.startDate || null}
          selectedEndDate={filter?.endDate || null}
        />
        <div className="record-binder-container">
          <InfiniteScroll
            dataLength={recordBindersData.length}
            hasMore={false}
            refreshFunction={this.onRefresh}
            pullDownToRefresh={true}
            pullDownToRefreshThreshold={50}
            pullDownToRefreshContent={
              <h3 style={{ textAlign: 'center' }}>
                &#8595; {localization[getLocale()].PULL_DOWN_TO_REFRESH}
              </h3>
            }
            releaseToRefreshContent={
              <h3 style={{ textAlign: 'center' }}>
                &#8593; {localization[getLocale()].RELEASE_TO_REFRESH}
              </h3>
            }
          >
            {hasRecordBinders ? (
              recordBindersData.map((item, index) => (
                <RecordBinderCard
                  key={`${item.record_binder_id}-${index}`}
                  item={item}
                  onCardPress={this.onCardPress}
                />
              ))
            ) : (
              <div className="no-records-result-found">
                <NoRecordsFound screenType={screenType} onButtonPress={this.onRefresh} />
              </div>
            )}
          </InfiniteScroll>
        </div>
      </AppContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  recordBinders: state.recordBinder.recordBinders,
  currentRecordBinder: state.recordBinder.currentRecordBinder,
  isLoading: state.recordBinder.isLoading,
  error: state.recordBinder.error,
  user: state.authentication.user,
  selectedFeedyard: state.authentication.selectedFeedyard,
  query: state.recordBinder.query,
  filter: state.recordBinder.filter,
});

const mapDispatchToProps = {
  getRecordBinders: getRecordBindersRequest,
  searchRecordBinders,
  filterRecordBinders,
  resetRecordBinderErrorProps,
  setCurrentRecordBinder,
  setBottomBarTab,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(RecordBinder));
